module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjgwMCI+PHBhdGggZmlsbD0iIzAwNUJCQiIgZD0iTTAgMGgxMjAwdjgwMEgweiIvPjxwYXRoIGZpbGw9IiNGRkQ1MDAiIGQ9Ik0wIDQwMGgxMjAwdjQwMEgweiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/ukr.svg
// module id = k3Al
// module chunks = 0